import * as PositionActions from 'app/core/store/actions/noms/position.actions';
import { initialState } from '../../states/noms/position.states';


export type Action = PositionActions.All

export function reducer(state = initialState, action: Action) {
    switch (action.type) {
        case PositionActions.GET_LIST_OPTIONS_SUCCESS : {
            return {
                ...state,
                listOptions: action.payload
            }
        }

        default: return state
    }
}
